const small = require('~/assets/images/magasin-excideuil-facade-800.webp')
const large = require('~/assets/images/magasin-excideuil-facade-1300.webp')

export const storeFacade = {
  srcset: `${small} 800w, ${large} 1300w`,
  sizes: '100vw',
  large,
  fallback: require('~/assets/images/magasin_agm_vision.png'),
}
